import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddRolesService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  public getAuthorizedRoles() {
    const url = `${this.apiUrl}Role/GetAuthorizedRoles`;
    return this.http.get<any>(url, this.httpOptions);
  }

  public updateRoles(object) {
    const url = `${this.apiUrl}Role/UpdateEmployeeRoles`;
    return this.http.put<any>(url, object, this.httpOptions);
  }
  public getCompetencies() {
    const url = `${this.apiUrl}Competency/GetCompetenciesForDropDowns`
    return this.http.get<any>(url, this.httpOptions);
  }
  public getSubCompetencies(value) {
    const url = `${this.apiUrl}Competency/GetSubCompetenciesForDropDowns?competencyId=${value}`
    return this.http.get<any>(url, this.httpOptions);
  }
  public postCompetencyLeader(value) {
    const url = `${this.apiUrl}CompetencyLeader/SaveCompetencyLeaderDetails`;
    return this.http.post<any>(url, value, this.httpOptions);
  }
  public getCompetencyLeader(value) {
    const url = `${this.apiUrl}CompetencyLeader/GetAllCompetencyLeaderRolesByEmployeeId?employeeId=${value}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public deleteCompetencyLeader(value) {
    const url = `${this.apiUrl}CompetencyLeader/DeleteCompetencyLeader?id=${value}`;
    return this.http.put<any>(url, this.httpOptions);
  }
}
